<template>
  <b-container fluid>
    <div class="row gpct_titles">
      <b-col cols="12" lg="9">
        <div class="m-auto card_view">
          <div class="iq-card p-3 row">
            <div class="col-12 d-flex">
              <b-avatar :style="{ border: '2px solid ' + gPathCareerData.color_code}" class="avatar-50 rounded" v-if="gPathCareerData.img">
                <img :v-if="gPathCareerData.img" :src="gPathCareerData.img" alt="career_image" style="width: 100%;">
              </b-avatar>
              <b-avatar v-else class="avatar-50 rounded" :text="getFirstLetterOfAString(gPathCareerData.title)" :style="{ border: '3px solid ' + gPathCareerData.color_code, backgroundColor: `${gPathCareerData.color_code} !important`}"></b-avatar>
              <h4 class="heading ml-3" :style="{color: `${gPathCareerData.color_code} !important`}">
                  {{gPathCareerData.title}}
              </h4>
            </div>
          </div>
          <b-row>
            <b-col class="col-12">
              <iq-card>
                <div class="p-2 d-flex justify-content-between align-items-center" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(87,166,219,1) 0%, rgba(98,107,176,1) 100%);">
                  <h4>About Career</h4>
                </div>
                <div class="card-body p-2"  style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(153,196,234,1) 0%, rgba(156,167,214,1) 100%);">
                  <span v-html="gPathCareerData.about.replaceAll('\r\n', '<br>')"></span>
                </div>
              </iq-card>
            </b-col>

            <!-- Career image -->
            <b-col class="col-12 col-sm-12 col-md-6">
              <img :src="randomAboutCareerImage" class="p-3 image_rendom"/>
            </b-col><!-- Career image -->

            <b-col class="col-12 col-sm-12 col-md-6">
              <iq-card>
                <div class="p-2 d-flex justify-content-between align-items-center" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(236,28,36,1) 0%, rgba(168,37,142,1) 100%);">
                  <h4>More about the Role</h4>
                </div>
                <div class="card-body image_data p-2" style="background: linear-gradient(90deg,#F89A9D 0%,#D282CA 100%);">
                  <div v-if="gPathCareerData.career_roles" v-html="gPathCareerData.career_roles.replaceAll('\r\n', '<br>')"></div>
                    <div v-else>&nbsp;</div>
                  </div>
              </iq-card>
            </b-col>

            <b-col class="col-12 col-sm-12 col-md-6">
              <iq-card>
                <div class="p-2 d-flex justify-content-between align-items-center" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(247,153,28,1) 0%, rgba(240,95,45,1) 100%);">
                  <h4>Subjects</h4>
                </div>
                <div class="card-body p-2" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(247,153,28,0.4) 0%, rgba(240,95,45,0.4) 100%);">
                  <div v-if="gPathCareerData.subjects" v-html="gPathCareerData.subjects.replaceAll('\r\n', '<br>')"></div>
                  <div v-else>&nbsp;</div>
                </div>
              </iq-card>
            </b-col>

            <b-col class="col-12 col-sm-12 col-md-6">
              <iq-card class="">
                <div class="p-2 d-flex justify-content-between align-items-center" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(83,197,213,1) 0%, rgba(78,180,230,1) 100%);">
                  <h4>Career Facts</h4>
                </div>
                <div class="card-body p-2" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(83,197,213,0.7) 0%, rgba(78,180,230,0.7) 100%);">
                  <div v-if="gPathCareerData.career_facts" v-html="gPathCareerData.career_facts.replaceAll('\r\n', '<br>')"></div>
                  <div v-else>&nbsp;</div>
                </div>
              </iq-card>
            </b-col>

            <b-col class="col-12 col-sm-12 col-md-6">
              <iq-card class="">
                <div class="p-2 d-flex justify-content-between align-items-center" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(87,166,219,1) 0%, rgba(98,107,176,1) 100%);">
                  <h4>Career Programs</h4>
                </div>
                <div class="card-body" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(87,166,219,0.7) 0%, rgba(98,107,176,0.7) 100%);">
                  <div v-if="gPathCareerData.programs" v-html="gPathCareerData.programs.replaceAll('\r\n', '<br>')"></div>
                  <div v-else>&nbsp;</div>
                </div>
              </iq-card>
            </b-col>

            <!-- Career salary -->
            <div class="col-12 col-sm-12 col-md-6">
              <iq-card>
                <div class="p-2 d-flex justify-content-between align-items-center" @click="toggleSection('salary')" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(236,28,36,1) 0%, rgba(168,37,142,1) 100%);">
                  <h4 class="mb-0">Career salary</h4>
                  <span :class="['arrow', isOpen.salary ? 'rotate' : '']">▼</span>
                </div>
                <div class="collapse" :class="{ show: isOpen.salary }"  style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,85,93,1) 0%, rgba(222,156,198,1) 100%);">
                  <div class="card-body p-2">
                    <div v-if="gPathCareerData.salary" v-html="gPathCareerData.salary.replaceAll('\r\n', '<br>')"></div>
                    <div v-else>&nbsp;</div>
                  </div>
                </div>
              </iq-card>
            </div>

            <!-- Hiring Companies -->
            <div class="col-12 col-sm-12 col-md-6">
              <iq-card>
                  <div class="p-2 d-flex justify-content-between align-items-center" @click="toggleSection('companies')" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(247,153,28,1) 0%, rgba(240,95,45,1) 100%);">
                    <h4 class="mb-0">Hiring Companies</h4>
                  </div>
                  <div>
                    <div class="card-body image_data p-2" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(247,153,28,0.7) 0%, rgba(240,95,45,0.7) 100%);">
                      <div v-if="gPathCareerData.hiring_companies" v-html="gPathCareerData.hiring_companies.replaceAll('\r\n', '<br>')"></div>
                      <div v-else>&nbsp;</div>
                    </div>
                  </div>
              </iq-card>
            </div><!-- Hiring Companies -->

            <!-- Hiring image -->
            <b-col class="col-12 col-sm-12 col-md-6">
              <img :src="randomCareerImage" class="image_rendom" />
            </b-col><!-- Hiring image -->

            <!-- Career Roadmap -->
            <div class="col-12 col-sm-12">
              <iq-card>
                <div class="p-2 d-flex justify-content-between align-items-center" @click="toggleSection('roadmap')" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(83,197,213,1) 0%, rgba(78,180,230,1) 100%);">
                  <h4 class="mb-0">Career Roadmap</h4>
                  <span :class="['arrow', isOpen.roadmap ? 'rotate' : '']">▼</span>
                </div>
                <div class="collapse" :class="{ show: isOpen.roadmap }" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(153,221,229,1) 0%, rgba(146,213,238,1) 100%);">
                  <div class="card-body p-2">
                    <div v-if="gPathCareerData.career_paths" v-html="gPathCareerData.career_paths.replaceAll('\r\n', '<br>')"></div>
                    <div v-else>&nbsp;</div>
                  </div>
                </div>
              </iq-card>
            </div>

            <!-- Career Myth -->
            <div class="col-12">
              <iq-card>
                <div class="p-2 d-flex justify-content-between align-items-center" @click="toggleSection('myth')" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(87,166,219,1) 0%, rgba(98,107,176,1) 100%);">
                  <h4 class="mb-0">Career Myth</h4>
                  <span :class="['arrow', isOpen.myth ? 'rotate' : '']">▼</span>
                </div>
                <div class="collapse" :class="{ show: isOpen.myth }" style="background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(153,196,234,1) 0%, rgba(156,167,214,1) 100%);">
                  <div class="card-body p-2">
                  <div v-if="gPathCareerData.career_myths" v-html="gPathCareerData.career_myths.replaceAll('\r\n', '<br>')"></div>
                    <div v-else>&nbsp;</div>
                  </div>
                </div>
              </iq-card>
            </div><!-- Career Myth -->
          </b-row>
        </div>
      </b-col>

      <b-col lg="3" class="d-none d-lg-block iq-card">
        <div class="p-2 mb-3">
          <h5>More Option In {{ gPathCareerData.name }}</h5>
        </div>
        <div v-if="gpath_careerObjTypeList && gpath_careerObjTypeList.length >0">
          <div v-for="(career,index) in gpath_careerObjTypeList" :key="index" class="col-12">
            <iq-card :style="{ borderLeft: '3px solid ' + career.color_code}"  @click="gpath_career_role_detail(career)">
              <template v-slot:body>
                  <div class="d-flex">
                    <b-avatar :style="{ border: '3px solid ' + career.color_code}" class="avatar-50 rounded" v-if="career.image">
                      <img :src="career.image" alt="career_image" style="width: 100%;">
                    </b-avatar>
                    <b-avatar v-else class="avatar-50 rounded" :text="getFirstLetterOfAString(career.title)" :style="{ border: '3px solid ' + career.color_code, backgroundColor: `${career.color_code} !important`}">
                    </b-avatar>
                    <h5 class="title twoLineOnly" style="cursor: pointer" :title="career.title" @click="gpath_career_role_detail(career)">
                      {{career.title}}
                    </h5>
                  </div>
              </template>
            </iq-card>
          </div>
        </div>
      </b-col>
    </div>
    <b-modal
      v-model="showModelGPathCareertypeAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <GPathCareerRoleAdd :propOpenedInModal="true" @emitCloseGPathCareertypeAddModal="closeGPathCareertypeAddModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeGPathCareertypeAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

  </b-container>
</template>
<script>
import { socialvue } from "../../../config/pluginInit"
// import userPermission from "../../../Utils/user_permission.js"
import { GPathCareerType } from "../../../FackApi/api/GPathCareerType"
import moment from "moment"
import GPathCareerRoleAdd from "./GPathCareerRoleAdd.vue"

export default {
  name: "GPathCareerListV1",
  components: {
    GPathCareerRoleAdd
  },
  props: {
    propGPathCareertypeObj: {
      type: Object,
      default: function () {
        return {
          name: ""
        }
      }
    }
  },
  data () {
    return {
      cvModuleFile: "gpath_career_view",
      apiName: "gpath_careers_view",
      isOpen: {
        myth: false,
        companies: false,
        roadmap: false,
        salary: false
      },
      gPathCareerData: {},
      CAREER_IMG_COUNT: 9,
      randomCareerImage: "",
      cvAddModalHeader: "Add Career",
      cvbtnAddNew: "Add",
      showModelGPathCareertypeAdd: false,
      cvbtnModalCancel: "Cancel",
      gpath_careerObjTypeList: [],
      randomAboutCareerImage: null,
      limit: "10",
      whereFilter: {
        careerRoleList: 1
      },
      gpctId: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    // if (!userPermission(this, this.userData, this.apiName)) {
    //   this.$router.back()
    // }
  },
  async mounted () {
    socialvue.index()
    await this.gpath_career_role_View()
    await this.gpath_career_roleList()
    this.randomImage()
  },
  methods: {
    toggleSection (section) {
      this.isOpen[section] = !this.isOpen[section]
    },
    /**
     * gpath_career_role_detail
     */
    gpath_career_role_detail (typeName) {
      this.$router.replace(`/gpath_career_role_detail/${typeName.gpct_id}`)
      this.randomImage()
      this.gpath_career_role_View()
    },
    /**
     * gpath_career_roleList
     */
    async gpath_career_roleList () {
      try {
        this.whereFilter.limit = this.limit
        this.whereFilter.name = this.gPathCareerData.name
        let gpathCareerRoleListResp = await GPathCareerType.gpath_career_roleList(this, this.currentPage, this.whereFilter)
        if (gpathCareerRoleListResp.resp_status) {
          this.gpath_careerObjTypeList = gpathCareerRoleListResp.resp_data.data

          if (gpathCareerRoleListResp.resp_data.totalPage) {
            this.totalPage = parseInt(gpathCareerRoleListResp.resp_data.totalPage)
          }
          if (this.currentPage && this.totalPage && this.currentPage >= this.totalPage) {
            this.showLoadMoreBtn = false
          }
          else {
            this.showLoadMoreBtn = true
          }
          this.totalPage = gpathCareerRoleListResp.resp_data.count
        }
        else {
          this.toastMsg = gpathCareerRoleListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_career_roleList() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_role_View
     */
    async gpath_career_role_View () {
      try {
        if (this.propOpenedInModal) {
          this.gPathCareerData = this.propGPathCareertypeObj
        }
        else {
          let gpathCareerTypeId = this.$route.params.gpct_id
          let gpathCareerTypeViewResp = await GPathCareerType.gpath_career_role_view(this, gpathCareerTypeId)

          if (gpathCareerTypeViewResp && gpathCareerTypeViewResp.resp_status) {
            this.gPathCareerData = gpathCareerTypeViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_role_View() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareertypeAddModal
     */
    closeGPathCareertypeAddModal (gpathCareerTypeAddData) {
      try {
        if (gpathCareerTypeAddData) {
          if (this.gpath_career_typeObjList && this.gpath_career_typeObjList.length >= 1) {
            let gpathCareerTypeObjLength = this.gpath_career_typeObjList.length
            let lastId = this.gpath_career_typeObjList[gpathCareerTypeObjLength - 1]["id"]
            gpathCareerTypeAddData.id = lastId + 1
          }
          else {
            this.gpath_career_typeObjList = []
            gpathCareerTypeAddData.id = 11111
          }

          gpathCareerTypeAddData.created_on = moment()
          this.gpath_career_typeObjList.unshift(gpathCareerTypeAddData)
          this.totalPage = this.totalPage + 1
        }

        this.showModelGPathCareertypeAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpath_career_typeAddModal() and Exception:", err.message)
      }
    },
    /**
     * getFirstLetterOfAString
     */
    getFirstLetterOfAString (string) {
      if (string) {
        return string.substr(0, 1)
      }
    },
    /**
     * random image
    */
    randomImage () {
      const randomIndex = Math.floor(Math.random() * this.CAREER_IMG_COUNT) + 1
      this.randomCareerImage = `/Career_pba/Hiring_companies${randomIndex}.jpg`
      this.randomAboutCareerImage = `/Career_pba/About_the_career${randomIndex}.jpg`
    }
  }
}
</script>
<style scoped>
.arrow {
  transition: transform 0.3s ease;
}
.rotate {
  transform: rotate(180deg);
}
.gpct_titles{
  color:#000 !important;
}
h5{
  color: #000 !important;
}
.twoLineOnly{
  align-content: center;
  display: block;
  padding-left: 10px;
}
.image_rendom{
    margin: auto;
    display: block;
    margin-bottom: 20px;
  }
@media (max-width: 767px) {
  .image_rendom{
    width: 50%;
  }
}
@media (min-width: 767px) {
  .card_view {
    width: 80%;
  }
  .image_data{
    min-height: 270px;
  }
  .image_rendom{
    min-height: 270px;
    height: 270px;
    width: unset;
  }
}
.heading{
  display: flex;
  align-items: center;
}
</style>
